/* Destilo PDP — gallery, quantity, accordions, variants, combine-with */
(function () {
  const money = (cents) =>
    (cents / 100).toLocaleString('es-ES', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
    });

  function init(root) {
    /* ---- Gallery carousel ---- */
    const track = root.querySelector('[data-pdp-track]');
    const slides = root.querySelectorAll('[data-pdp-slide]');
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');
    const thumbsStrip = root.querySelector('[data-pdp-thumbs]');
    if (track && slides.length > 1) {
      let index = 0;
      const go = (i) => {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === index));
        // Centre the active thumb INSIDE the strip only — never scroll the page.
        const active = thumbs[index];
        if (active && thumbsStrip) {
          const stripRect = thumbsStrip.getBoundingClientRect();
          const within = active.getBoundingClientRect().left - stripRect.left + thumbsStrip.scrollLeft;
          const target = within - (thumbsStrip.clientWidth - active.clientWidth) / 2;
          thumbsStrip.scrollTo({ left: target, behavior: 'smooth' });
        }
      };
      const prev = root.querySelector('[data-pdp-prev]');
      const next = root.querySelector('[data-pdp-next]');
      if (prev) prev.addEventListener('click', () => go(index - 1));
      if (next) next.addEventListener('click', () => go(index + 1));
      thumbs.forEach((t, n) => t.addEventListener('click', () => go(n)));

      // Swipe (touch) on the main image
      let startX = null;
      track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', (e) => {
        if (startX == null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      });

      // Thumbnail strip arrows (horizontal scroll when there are many)
      const tPrev = root.querySelector('[data-pdp-thumbs-prev]');
      const tNext = root.querySelector('[data-pdp-thumbs-next]');
      if (thumbsStrip && tPrev && tNext) {
        const amount = () => Math.max(120, thumbsStrip.clientWidth * 0.7);
        const updateArrows = () => {
          const overflow = thumbsStrip.scrollWidth > thumbsStrip.clientWidth + 4;
          tPrev.hidden = !overflow;
          tNext.hidden = !overflow;
          if (overflow) {
            tPrev.disabled = thumbsStrip.scrollLeft <= 2;
            tNext.disabled = thumbsStrip.scrollLeft + thumbsStrip.clientWidth >= thumbsStrip.scrollWidth - 2;
          }
        };
        tPrev.addEventListener('click', () => thumbsStrip.scrollBy({ left: -amount(), behavior: 'smooth' }));
        tNext.addEventListener('click', () => thumbsStrip.scrollBy({ left: amount(), behavior: 'smooth' }));
        thumbsStrip.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }
    }

    /* ---- Sticky gallery: follow the on-scroll-up header ---- */
    const gallery = root.querySelector('.pdp__gallery');
    const stickyHeader = document.querySelector('sticky-header');
    if (gallery && stickyHeader && window.matchMedia('(min-width: 990px)').matches) {
      const GAP = 20;
      const updateTop = () => {
        const headerShown = !stickyHeader.classList.contains('shopify-section-header-hidden');
        const h = stickyHeader.offsetHeight || 0;
        const topGap = headerShown ? h + GAP : GAP;

        /* La galería a ancho completo es más alta que la ventana. Si se anclara por
           arriba, su parte inferior —las miniaturas, único modo de llegar a la foto
           de ambiente— no se alcanzaría nunca: por eso, cuando no cabe, se ancla por
           ABAJO (top negativo) y se recorre entera al bajar. */
        const libre = window.innerHeight - topGap;
        const top = gallery.offsetHeight <= libre ? topGap : window.innerHeight - gallery.offsetHeight - GAP;
        gallery.style.top = top + 'px';
      };

      updateTop();
      window.addEventListener('scroll', updateTop, { passive: true });
      window.addEventListener('resize', updateTop);
      /* La altura real solo se conoce cuando cargan las imágenes. */
      if (window.ResizeObserver) new ResizeObserver(updateTop).observe(gallery);
    }

    /* ---- Quantity stepper ---- */
    const qty = root.querySelector('[data-pdp-qty]');
    if (qty) {
      const input = qty.querySelector('[data-pdp-qty-input]');
      qty.querySelectorAll('[data-action]').forEach((btn) => {
        btn.addEventListener('click', () => {
          let v = parseInt(input.value, 10) || 1;
          v = btn.dataset.action === 'plus' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    }

    /* ---- Variant buttons (Formato) ---- */
    const variantInput = root.querySelector('[data-pdp-variant-id]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const compareEl = root.querySelector('[data-pdp-compare]');
    const addBtn = root.querySelector('.pdp__add');
    const addText = root.querySelector('[data-pdp-add-text]');
    root.querySelectorAll('[data-pdp-variant]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        root.querySelectorAll('[data-pdp-variant]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice;
        // Precio comparado (rebaja) por variante
        if (compareEl) {
          const cmp = btn.dataset.variantCompare;
          if (cmp) {
            compareEl.textContent = cmp;
            compareEl.hidden = false;
            if (priceEl) priceEl.classList.add('pdp__price--sale');
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
            if (priceEl) priceEl.classList.remove('pdp__price--sale');
          }
        }
      });
    });

    /* ---- Add to cart (works like the theme's original button) ---- */
    const form = root.querySelector('[data-pdp-form]');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const id = Number(variantInput ? variantInput.value : 0);
        const qtyInput = form.querySelector('[name="quantity"]');
        const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        if (!id || (addBtn && addBtn.disabled)) return;

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const sectionIds =
          cart && cart.getSectionsToRender ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];

        if (addBtn) {
          addBtn.classList.add('is-loading');
          addBtn.disabled = true;
          if (addText) addText.dataset.prev = addText.textContent;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: id, quantity: quantity }],
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((json) => {
            if (json.status) return; // error (sold out / not purchasable)
            const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cartEl && typeof cartEl.renderContents === 'function') {
              cartEl.renderContents(json); // updates drawer + opens it
              cartEl.classList.remove('is-empty');
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp', productVariantId: id, cartData: json });
            }
          })
          .catch(() => {})
          .finally(() => {
            if (addBtn) {
              addBtn.classList.remove('is-loading');
              addBtn.disabled = false;
            }
          });
      });
    }

    /* ---- Accordions handled by accordion.js (shared, smooth height anim) ---- */

    /* ---- Wishlist (persisted by handle, shared with the favorites page) ---- */
    const wish = root.querySelector('.pdp__wishlist');
    if (wish) {
      const KEY = 'destilo_wishlist';
      const handle = wish.dataset.productHandle;
      const read = () => {
        try {
          return JSON.parse(localStorage.getItem(KEY)) || [];
        } catch (e) {
          return [];
        }
      };
      if (handle && read().includes(handle)) wish.classList.add('is-active');
      wish.addEventListener('click', () => {
        if (!handle) return;
        const list = read();
        const i = list.indexOf(handle);
        if (i > -1) {
          list.splice(i, 1);
          wish.classList.remove('is-active');
        } else {
          list.push(handle);
          wish.classList.add('is-active');
        }
        localStorage.setItem(KEY, JSON.stringify(list));
        /* Sube el cambio a la cuenta si hay sesión (assets/wishlist-sync.js). */
        if (window.DestiloWishlistSync) window.DestiloWishlistSync.push();
      });
    }

    /* ---- Combine with (complementary products) — carousel ---- */
    const combine = root.querySelector('[data-pdp-combine]');
    if (combine && combine.dataset.url) {
      fetch(combine.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('.pdp-combine-item');
          if (!items.length) return;
          const track = combine.querySelector('[data-pdp-combine-list]');
          items.forEach((it) => track.appendChild(it));
          combine.hidden = false;
          initCombineCarousel(combine, track);
          bindCombineCart(combine);
        })
        .catch(() => {});
    }
  }

  function bindCombineCart(root) {
    const state = {};
    const getQty = (v) => state[v] || 0;

    async function refresh() {
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        Object.keys(state).forEach((k) => delete state[k]);
        cart.items.forEach((i) => { state[i.variant_id] = i.quantity; });
      } catch (e) {
        /* noop */
      }
    }

    function render(cartEl) {
      const q = getQty(cartEl.dataset.variantId);
      const lbl = cartEl.querySelector('.pdp-combine-item__qty-label');
      if (q > 0) {
        cartEl.classList.add('is-in-cart');
        const item = cartEl.closest('.pdp-combine-item');
        const unit = item ? parseInt(item.dataset.price, 10) || 0 : 0;
        const cRoot = cartEl.closest('[data-pdp-combine]');
        const inCart = (cRoot && cRoot.dataset.inCartLabel) || 'in cart';
        if (lbl) lbl.textContent = q + ' ' + inCart + ' — ' + money(unit * q);
      } else {
        cartEl.classList.remove('is-in-cart');
      }
    }

    async function sync() {
      await refresh();
      root.querySelectorAll('.pdp-combine-item__cart').forEach(render);
    }

    function applySections(cart, json) {
      if (!json.sections) return;
      cart.getSectionsToRender().forEach((section) => {
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        const html = json.sections[section.id];
        if (!target || html == null) return;
        const source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(section.selector || '.shopify-section');
        target.innerHTML = source ? source.innerHTML : html;
      });
      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof cart.close === 'function') overlay.addEventListener('click', cart.close.bind(cart));
      const total = Object.values(state).reduce((a, b) => a + b, 0);
      cart.classList.toggle('is-empty', total === 0);
    }

    async function change(variantId, quantity, cartEl) {
      quantity = Math.max(0, quantity);
      const isAdd = getQty(variantId) === 0 && quantity > 0;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const ids = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
      const payload = { sections: ids.join(','), sections_url: window.location.pathname };
      if (cartEl) cartEl.classList.add('is-loading');
      try {
        let res;
        if (isAdd) {
          res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }], ...payload }),
          });
        } else {
          res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(variantId), quantity: quantity, ...payload }),
          });
        }
        const json = await res.json();
        await refresh();
        render(cartEl);
        if (cart && cart.getSectionsToRender) applySections(cart, json);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-combine', cartData: json });
        }
      } catch (e) {
        /* noop */
      } finally {
        if (cartEl) cartEl.classList.remove('is-loading');
      }
    }

    root.addEventListener('click', (e) => {
      const add = e.target.closest('.pdp-combine-item__add');
      const qtyBtn = e.target.closest('.pdp-combine-item__qty-btn');
      if (add) {
        const cell = add.closest('.pdp-combine-item__cart');
        change(cell.dataset.variantId, getQty(cell.dataset.variantId) + 1, cell);
      } else if (qtyBtn) {
        const cell = qtyBtn.closest('.pdp-combine-item__cart');
        const delta = qtyBtn.dataset.action === 'increase' ? 1 : -1;
        change(cell.dataset.variantId, getQty(cell.dataset.variantId) + delta, cell);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        if (ev && ev.source === 'pdp-combine') return;
        sync();
      });
    }

    sync();
  }

  function initCombineCarousel(root, track) {
    const items = Array.from(track.children);
    const dataPv = parseInt(root.dataset.perView, 10) || 3;
    const nav = root.querySelector('[data-combine-nav]');
    const prev = root.querySelector('[data-combine-prev]');
    const next = root.querySelector('[data-combine-next]');
    const viewport = root.querySelector('.pdp__combine-viewport');
    let index = 0;
    let dir = 1;
    let timer = null;

    if (!items.length) return;

    const step = () => {
      if (!items[0]) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    };
    // Per-view derivado del layout real: móvil = 2, tablet = 3, etc. (igual que el
    // carrusel de blog). Antes usaba data-per-view fijo y en móvil saltaba de 3 en 3.
    const perView = () => {
      const s = step();
      if (!s) return dataPv;
      const w = (viewport || track).getBoundingClientRect().width;
      return Math.max(1, Math.round(w / s));
    };
    const maxIndex = () => Math.max(0, items.length - perView());
    const apply = () => {
      const max = maxIndex();
      if (index > max) index = max;
      if (index < 0) index = 0;
      track.style.transform = 'translateX(' + -index * step() + 'px)';
      if (nav) nav.hidden = items.length <= perView();
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= max;
    };
    const go = (i) => {
      index = Math.max(0, Math.min(maxIndex(), i));
      apply();
    };

    // Autoplay (ping-pong: bounces back at the ends, no abrupt jump)
    const autoplay = root.dataset.autoplay === 'true';
    const interval = Math.max(1, parseFloat(root.dataset.interval) || 4) * 1000;
    const tick = () => {
      if (index >= maxIndex()) dir = -1;
      else if (index <= 0) dir = 1;
      go(index + dir);
    };
    const start = () => {
      if (autoplay && !timer) timer = setInterval(tick, interval);
    };
    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    const restart = () => {
      stop();
      start();
    };

    if (prev) prev.addEventListener('click', () => { dir = -1; go(index - 1); restart(); });
    if (next) next.addEventListener('click', () => { dir = 1; go(index + 1); restart(); });
    window.addEventListener('resize', apply);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    apply();
    start();
  }

  function boot() {
    document.querySelectorAll('[data-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
